import { makeAutoObservable } from "mobx";
import DatasetStorage from "../../core/workspace/dataset-storage/DatasetStorage";

export interface IncludeIntent {
  id: number;
  text: string;
}

class IntentEditor {
  name = "";
  templatePhrase = "";
  phrases: IncludeIntent[] = [];
  maxNameLength = 60;

  constructor(readonly dataset: DatasetStorage) {
    makeAutoObservable(this);
  }

  get isValidName() {
    return this.dataset.intents.includes(this.name) === false;
  }

  get isValid() {
    return this.phrases.length >= 5 && this.name.length > 0 && this.isValidName;
  }

  setTemplatePhrase(name: string) {
    this.templatePhrase = name;
  }

  setName(name: string) {
    this.name = name.slice(0, 60).replaceAll(" ", "_");
  }

  applyTemplate() {
    if (this.templatePhrase.length === 0) return;
    this.phrases.push({ id: Date.now(), text: this.templatePhrase });
    this.templatePhrase = "";
  }

  removePhrase(id: number) {
    const index = this.phrases.findIndex((v) => v.id === id);
    if (index === -1) return;
    this.phrases.splice(index, 1);
  }

  renamePhrase(phrase: IncludeIntent, text: string) {
    phrase.text = text;
  }

  serialize() {
    return {
      name: this.name,
      includes: this.phrases.map((v) => v.text),
      excludes: [],
    };
  }
}

export default IntentEditor;
